"use client"

import {EventResponse, eventResponseModeSchema, eventStatusSchema, EventWithResponses} from "@vereinsheim/backend-types/src/event";
import {Card} from "@/app/pwa/components/Card";
import {EventCardTitleInfo} from "./EventCardTitleInfo";
import {useUserPersons} from "@/app/pwa/lib/pwa-context";
import {
  EventCardAttendancePicker,
  useEventPersons
} from "@/app/pwa/components/event/EventCard/EventCardAttendancePicker";
import {useAbility} from "@/app/pwa/lib/ability-context";
import {subject} from "@casl/ability";
import {useMemo, useState} from "react";
import {useSession} from "next-auth/react";
import {EventWrapper} from "@/app/pwa/(main-layout)/events/lib/types";
import {isRegularEventWrapper} from "@/app/pwa/(main-layout)/events/lib/helper";
import { Person } from "@/sources/kicker-amateur/types";

interface EventCardProps {
  eventWrapper: EventWrapper,
  showTeamNames:boolean,
}

export function EventCard({ eventWrapper, showTeamNames=false}: EventCardProps) {
  const ability = useAbility();
  const hasShowPermissionForEvent = ability.can("show", subject("Event", {clubId: eventWrapper.event.appId}))
  const [responses, setResponses] = useState(eventWrapper.event.responses)
  const {data: session} = useSession();
  const user = session?.user
  const userPersons = useUserPersons();
  const persons:Person[] = useEventPersons(eventWrapper,user?.personFunctions ?? [],userPersons)
  const isPast = useMemo(() => eventWrapper.start < new Date().getTime(),[eventWrapper.start])

  function handleResponseChange(response: EventResponse) {
    setResponses({...responses, [response.personId]: response.status})
  }

  const responseMode = eventWrapper.event.responseMode;
  const userActionExpected = !persons.every((person) => Object.keys(responses).includes(person.Id?.toString()??"")) && responseMode != "default-accepted" && responseMode != "default-declined" && responseMode != "default-unknown"
  const showAttendancePicker = useMemo(() =>
    !isPast && hasShowPermissionForEvent && responseMode != eventResponseModeSchema.enum.disabled && persons.length > 0
  ,[hasShowPermissionForEvent, isPast, persons.length, responseMode])

  const isCanceled = isRegularEventWrapper(eventWrapper ) && eventWrapper.event.status === eventStatusSchema.enum.canceled;
  return (
    <div>
      {/* <Card p={false} className={`p-1 relative ${userActionExpected ? "outline-2 outline-team outline" : "" }`}> */}
      <Card p={false} className={`p-1 relative ${isCanceled ? "opacity-60" : ""}`}>
        {!isPast && userActionExpected && <div className="absolute right-1 top-1 w-3 h-3 bg-team rounded-full"></div>}
        <EventCardTitleInfo showTeamNames={showTeamNames} eventWrapper={eventWrapper} isCanceled={isCanceled} />
        {showAttendancePicker && <EventCardAttendancePicker onResponseChange={handleResponseChange} showAttendees={true} eventWrapper={eventWrapper}/>}
      </Card>
    </div>
  );
}
